import { render, staticRenderFns } from "./ProjectSettingsForm.vue?vue&type=template&id=e81c6522&"
import script from "./ProjectSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectSettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports